import { EntityType } from '@nkr/enums/entity-type';
import useAllowDuplicateOverride from '@nkr/store/allow-duplicate/hooks/use-allow-duplicate-override';
import { useState } from 'react';
import { Alert, Button, ControlLabel, FormControl, Modal, Radio } from 'react-bootstrap';
import { styles } from './styles';

interface IProps {
    entityType: EntityType,
    profileId: number
}

const AllowDuplicateControl = (props: IProps) => {
    const { isAllowed, loading, error, allow, revoke } = useAllowDuplicateOverride(props.entityType, props.profileId);

    const [pendingValue, setPendingValue] = useState<boolean>(null);
    const [reason, setReason] = useState<string>('');

    const handleChange = (value: boolean) => {
        if (value == isAllowed) {
            return;
        }

        setReason('');
        setPendingValue(value);
    };

    const handleCancel = () => {
        setPendingValue(null);
        setReason('');
    };

    const handleConfirm = async () => {
        if (pendingValue) {
            await allow(reason);
        } else {
            await revoke(reason);
        }

        setPendingValue(null);
        setReason('');
    };

    return (
        <>
            <div style={styles.radioWell}>
                <Radio
                    inline
                    id='allowDuplicateYes'
                    name='allowDuplicate'
                    checked={isAllowed}
                    disabled={loading}
                    onChange={() => handleChange(true)}
                >
                    Yes
                </Radio>
                <Radio
                    inline
                    id='allowDuplicateNo'
                    name='allowDuplicate'
                    checked={!isAllowed}
                    disabled={loading}
                    onChange={() => handleChange(false)}
                >
                    No
                </Radio>
            </div>

            {error != '' &&
                <Alert bsStyle='danger' style={styles.error}>{error}</Alert>
            }

            <Modal
                backdrop='static'
                show={pendingValue != null}
                onHide={handleCancel}
                style={styles.modal}
                backdropStyle={styles.modalBackdrop}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{pendingValue ? 'Allow Duplicate' : 'Remove Allow Duplicate'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pendingValue &&
                        <Alert bsStyle='warning' style={styles.warning}>
                            Saves that would otherwise be blocked as a duplicate will be permitted for this profile.
                        </Alert>
                    }

                    <ControlLabel htmlFor='allowDuplicateReason'>Reason</ControlLabel>
                    <FormControl
                        componentClass='textarea'
                        id='allowDuplicateReason'
                        rows={3}
                        maxLength={500}
                        value={reason}
                        onChange={(e: React.FormEvent<FormControl & HTMLTextAreaElement>) => setReason(e.currentTarget.value)}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCancel} disabled={loading}>Cancel</Button>
                    <Button bsStyle='primary' onClick={handleConfirm} disabled={loading || reason.trim() == ''}>Confirm</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AllowDuplicateControl;
